import Vue from 'vue'

//Логика получения данных ответа для Axios
const getAxiosResponsePayload = (response)=>response.data;

export const postLogin = ({ login, password }) => Vue.axios.post('/auth/login', { login, password }).then(getAxiosResponsePayload);

export const loadUserData = () => Vue.axios.get('/api/auth/user').then(getAxiosResponsePayload);

export const revokeToken = () => Vue.axios.post('/auth/token/revoke').then(getAxiosResponsePayload);
